export const bookingTypes = ["Classique", "Booking", "AirBnb", "Fermeture"];
